import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
  inject,
  signal
} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subject, filter, map, startWith, takeUntil } from 'rxjs';

@Component({
  selector: 'app-bottom-bar',
  templateUrl: './bottom-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomBarComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly noFooterURLs = [
    'beneficiary/detail',
    'account/edit-profile',
    'account/remitter-profile',
    'account/my-voucher',
    'account/contact-us',
    'account/faq',
    'account/t&c',
    'account/privacy'
  ];
  private readonly _shouldBeHidden = signal(false);
  protected readonly shouldBeHidden = this._shouldBeHidden.asReadonly();
  private readonly destroy$ = new Subject<void>();
  protected isWebview: boolean = false;
  ngOnInit() {
    const userAgent = navigator.userAgent.toLowerCase();
    let safari = /safari/.test(userAgent);
    let ios = /iphone|ipod|ipad/.test(userAgent);
    if (userAgent.indexOf('wv') > -1 || userAgent.indexOf('webview') > -1 || (!safari && ios)) {
      this.isWebview = true;
    }
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(e => e instanceof NavigationStart),
        map(event => (event as NavigationStart).url),
        startWith(this.router.url),
        map(url => this.noFooterURLs.some(noFooterURL => url.includes(noFooterURL)))
      )
      .subscribe(_shouldBeHidden => {
        this._shouldBeHidden.set(_shouldBeHidden);
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
